import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import { IStyle } from 'Styles/styleModel';

interface SynchTripCardProps {
  synchTripName: string;
  beamLine: string;
  detectorType: string;
  dataCollectionDate: Date;
  onClick: () => void;
  isSelected: boolean;
  status?: number;
}

const SynchTripCard = (props: SynchTripCardProps) => {
  const {
    synchTripName,
    beamLine,
    detectorType,
    dataCollectionDate,
    onClick,
    isSelected,
    status,
  } = props;
  return (
    <div id='exp-synchtripcard-wrapper'
      onClick={onClick}
      className={`${
        isSelected && 'bg-blue-300'
      } flex flex-row align-center cursor-pointer hover:bg-blue-100 py-8`}
      style={styles.root}
    >
      <div id='exp-synchtripcard-icon-wrapper' style={{ paddingInline: '1%' }}>
        <RMSvgIcon
          id='exp-synchtripcard-actions-icon'
          name={!!status ? 'SynchrotronTrip' : 'SynchrotronTripv4_Open'}
          fill="none"
          width={25}
          height={25}
        />
      </div>
      <div id='exp-synchtripcard-container' className="flex flex-column">
        <div id='exp-synchtripcard-trip' className="flex flex-row">
          <div id={`exp-synchtripcard-trip-heading-${synchTripName}`} style={styles.heading}>{synchTripName}</div>
          <div id={`exp-synchtripcard-trip-time-${dataCollectionDate?.toLocaleDateString('en-US')}`} style={styles.tripTime}>
            {dataCollectionDate?.toLocaleDateString('en-US')}
          </div>
        </div>
        <div id='exp-synchtripcard-synch' className="flex flex-row">
          <div id={`exp-synchtripcard-synch-beam-${beamLine}`} style={styles.beam}>{beamLine}</div>
          <div id={`exp-synchtripcard-synch-detector-${detectorType}`} style={styles.detector}>{detectorType}</div>
        </div>
      </div>
    </div>
  );
};
const styles: IStyle = {
  root: {
    width: '100%',
    height: '6vh',
  },
  heading: {
    fontSize: 15,
    width: '20vw',
  },
  beam: {
    fontSize: 15,
    width: '12vw',
  },
  tripTime: {
    color: '#808080',
    fontSize: 15,
  },
  detector: {
    fontSize: 15,
  },
};

export default SynchTripCard;
